import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { addPayrollPartnerRoute, onBoardingPackagaeRoute } from '../api/constants';
import { onboardPackagesList, payrollpartnersList } from '../constants';
import { jobPostingsKey, profileKey } from '@staffedupusa/shared-components';
import { updateWalkthroughStatus } from '@utils/updateOnboardingStatus';
import { useUpdateStatus } from '@features/profile/hooks/useUpdateStatus';

type useAddOnboardingPackageProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useAddOnboardingPackage = ({
    setErrorText,
}: useAddOnboardingPackageProps) => {
    const client = useQueryClient();
    const { updateStatus } = useUpdateStatus({});
    const { mutate: addOnboardPackage, isLoading: isAddingOnboardPackage } =
        useMutation({
            mutationFn: (variables: {
                package_name?: string;
                joblisting_ids?: string;
                package_id?: number;
                update?: number;
                template_ids: string;
                company_id?: number;
            }) =>
                axiosInstance
                    .post(onBoardingPackagaeRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries(onboardPackagesList);
                    client.invalidateQueries(jobPostingsKey);
                    client.invalidateQueries(profileKey);
                    if (data?.object?.company){
                        updateWalkthroughStatus(data?.object?.company?.plan, data?.object, undefined, updateStatus);
                    }
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        addOnboardPackage,
        isAddingOnboardPackage,
    };
};
